import React from 'react';
import { Code, Briefcase, Rocket } from 'lucide-react';
const milestones = [{
  year: '16 Jahre',
  title: 'Der Anfang',
  description: 'Erstes Gewerbe gegründet. Neben der Schule Web-Apps entwickelt mit PHP, JavaScript, CSS und Python. Praktika und Projekte bei einer IT-Firma.',
  icon: Code,
  color: 'bg-blue-500'
}, {
  year: '17-19 Jahre',
  title: 'Der Wendepunkt',
  description: 'Vollzeit Webdesign- und Web-App-Entwicklungsagentur aufgebaut. Ein Kunde fragte nach einem CRM-System für seine Leads – das war der Startschuss.',
  icon: Briefcase,
  color: 'bg-purple-500'
}, {
  year: '19-23 Jahre',
  title: 'CRM Kraft',
  description: 'Vollzeit-Fokus auf CRM-Systeme. Durch Empfehlungen gewachsen. Heute arbeiten wir mit über 1.200 Vertrieblern zusammen.',
  icon: Rocket,
  color: 'bg-[#FF5722]'
}];
export function JourneyTimeline() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-142">
            Mein Weg zum CRM-Experten
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto" data-id="element-143">
            Keine Theorie, sondern jahrelange Praxis-Erfahrung in Entwicklung
            und Vertrieb.
          </p>
        </div>

        <div className="relative" data-id="element-144">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-[#1E293B] -translate-y-1/2 z-0" data-id="element-145"></div>

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-0 left-8 h-full w-1 bg-[#1E293B] z-0" data-id="element-146"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-147">
            {milestones.map((milestone, index) => <div key={index} className="relative flex flex-col md:items-center md:text-center pl-20 md:pl-0 group" data-id="element-148">
                {/* Icon Marker */}
                <div className={`absolute left-0 md:left-1/2 md:-translate-x-1/2 top-0 md:top-1/2 md:-translate-y-[calc(50%+3rem)] w-16 h-16 rounded-full ${milestone.color} flex items-center justify-center shadow-lg shadow-black/50 border-4 border-[#0A0E27] transition-transform duration-300 group-hover:scale-110`} data-id="element-149">
                  <milestone.icon className="w-8 h-8 text-white" data-id="element-150" />
                </div>

                {/* Content Card */}
                <div className="mt-4 md:mt-32 bg-[#141B3A] border border-[#1E293B] p-6 rounded-xl hover:border-[#334155] transition-colors w-full" data-id="element-151">
                  <div className="inline-block px-3 py-1 rounded-full bg-[#1E293B] text-[#FF5722] text-sm font-bold mb-3 border border-[#334155]" data-id="element-152">
                    {milestone.year}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-153">
                    {milestone.title}
                  </h3>
                  <p className="text-[#94A3B8] text-sm leading-relaxed" data-id="element-154">
                    {milestone.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}